import Dexie, { Table } from 'dexie';
import Channel from '../models/Channel';
import User from '../models/User';
import Config from '../models/Config';
import Constants from '../config/Constants';
import Message from '../models/Message';
import { logger } from '../../utils/Logger';
import Ticket from '../models/CareTicket';

Dexie.debug = import.meta.env.VITE_APP_STAGE !== 'production';

class MytChatDB extends Dexie {
  channel!: Table<Channel, string>;
  message!: Table<Message, string>;
  user!: Table<User, string>;
  ticket!: Table<Ticket, string>;

  constructor() {
    super(Constants.DATABASE_NAME);

    this.version(1).stores({
      channel: '&uuid, type, unread, isInviteActionPending', // Primary key and indexed props
      message: '&id, state, timeHandle, [channel+state], [channel+type], [channel+timeHandle]',
      user: '&uuid',
      ticket: '&user, role'
    });

    // v2: compound [role+timestamp] index for pre-sorted ticket retrieval per
    // role. Lets ChatHome use an exact-case index lookup instead of a
    // case-insensitive scan, and returns rows already in timestamp order so
    // the JS sort has near-sorted input. Existing data is auto-reindexed.
    this.version(2).stores({
      channel: '&uuid, type, unread, isInviteActionPending',
      message: '&id, state, timeHandle, [channel+state], [channel+type], [channel+timeHandle]',
      user: '&uuid',
      ticket: '&user, role, timestamp, [role+timestamp]'
    });

    this.channel.mapToClass(Channel);
    this.message.mapToClass(Message);
    this.user.mapToClass(User);
    this.ticket.mapToClass(Ticket);
  }

  clear = async () => {
    Config.shared.clear();

    await this.clearTables();

    await db.delete();
    logger.leaveBreadcrumb('database succussfully cleared.');
  };

  clearTables = async () => {
    const promises = [
      this.channel.clear(),
      this.message.clear(),
      this.user.clear(),
      this.ticket.clear()
    ];

    await Promise.all(promises);
    logger.leaveBreadcrumb('all tables succussfully cleared.');
  };
}

export const db = new MytChatDB();
